import type { MaterialSrc } from "../materialSrc";

/* eslint-disable @typescript-eslint/naming-convention */

// Worker-safe extracted defaults from the generated design material library.
// Keep this file limited to the small set of material sources needed by the
// standalone showroom worker and other bundle-sensitive entrypoints.
// Alias names intentionally encode the canonical `designMaterialPath` lookup so
// regression tests can verify parity without maintaining a second mapping table.
export const MS_Carpet__L__Carpet_Texture__Carpet_Texture_Oatmeal: MaterialSrc = {
  layerConfigId: 0,
  templateId: 0,
};

export const MS_Color__C: MaterialSrc = {
  templateId: 2,
};

export const MS_Color_PlanFloor__Default: MaterialSrc = {
  templateId: 1,
};

export const MS_Floor_Concrete__Default: MaterialSrc = {
  templateId: 3,
};

export const MS_Floor_Tile_Carrara__Default: MaterialSrc = {
  templateId: 4,
};

export const MS_Glass_Base__Default: MaterialSrc = {
  templateId: 8,
};

export const MS_Grass_Lawn_01__Default: MaterialSrc = {
  templateId: 10,
};

export const MS_Gravel__Default: MaterialSrc = {
  templateId: 106,
};

export const MS_Metal_Powder__C: MaterialSrc = {
  templateId: 12,
};

export const MS_Metal_Screen__Default: MaterialSrc = {
  templateId: 13,
};

export const MS_Paint_Egg__C: MaterialSrc = {
  templateId: 14,
};

export const MS_Paint_Satin__C: MaterialSrc = {
  templateId: 17,
};

export const MS_Paint_SemiGloss__C: MaterialSrc = {
  templateId: 18,
};

export const MS_Tree_Foliage_Generic__Default: MaterialSrc = {
  templateId: 37,
};

export const MS_Wall_VerticalBoard08__Default: MaterialSrc = {
  templateId: 95,
};

export const MS_Wood_StaggeredPlank__L__Wood_StaggeredPlank__StaggeredPlank_Tower: MaterialSrc = {
  layerConfigId: 83,
  templateId: 99,
};
